// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bihydsvtrmclovmxbypc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJpaHlkc3Z0cm1jbG92bXhieXBjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcxMTY2MzYsImV4cCI6MjA2MjY5MjYzNn0.-fe0etGyi9LDWR-x27KXAQK2tsHi5uJdSXH2FeOBsdg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);